import Router from "./Router";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store, persistor } from "./Redux/store";
import { PersistGate } from "redux-persist/integration/react";
import { ToastContainer } from "react-toastify";
import { ThemeProvider } from "@material-tailwind/react";
import { GoogleOAuthProvider } from "@react-oauth/google";
import Loader from "./Components/Loader";
import 'bootstrap/dist/js/bootstrap.bundle.min';

function App() {
  const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';
  
  return (
    <GoogleOAuthProvider clientId={clientId}>
      <BrowserRouter>
        <Provider store={store}>
          <PersistGate loading={<Loader />} persistor={persistor}>
            <ThemeProvider>
              <Router />
            </ThemeProvider>
            <ToastContainer />
          </PersistGate>
        </Provider>
      </BrowserRouter>
    </GoogleOAuthProvider>
  );
}

export default App;
